import TransactionNewForm from "../Components/TransactionNewForm";

function New() {
  return (
    <div className="p-4">
          <h2>New Transaction</h2>
          <br/>
      <TransactionNewForm />
    </div>
  );
}

export default New;
